var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100%" }, attrs: { grow: "" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("pdf-preview")) + " "),
          _c("w-spacer"),
          _vm.layout
            ? _c("w-checkbox", {
                style: { fontSize: "13px" },
                attrs: { label: _vm.$ct("label-show-margin-ruler") },
                model: {
                  value: _vm.layout.EditorSettings.ShowMarginRuler,
                  callback: function ($$v) {
                    _vm.$set(_vm.layout.EditorSettings, "ShowMarginRuler", $$v)
                  },
                  expression: "layout.EditorSettings.ShowMarginRuler",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("w-card-content", { style: { padding: "0 0 0 0" } }, [
        _c("iframe", { attrs: { id: "pdf-frame", src: _vm.url } }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }